import script from "./BaseFormAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFormAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./BaseFormAttachment.vue?vue&type=style&index=0&id=64d787d2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64d787d2"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
